// libraries
import { Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

// utils
import { txt } from '../../../locales/i18n';

export function ReportListHeader({ loading, totalMatches }: any): JSX.Element {
	return (
		<Typography.Text type="secondary" style={{ padding: '1ch' }}>
			{loading ? <LoadingOutlined /> : txt('global.table query notification', { amount: totalMatches })}
		</Typography.Text>
	);
}
